import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { FC } from 'react';

type TContactSectionProps = {
  formUrl?: string | undefined;
  bannerBg?: string | undefined;
  isLoading?: boolean | undefined;
};

export const ContactSection: FC<TContactSectionProps> = props => {
  const { formUrl, bannerBg, isLoading } = props;
  const theme = useTheme();

  return (
    <Container maxWidth="xl" sx={{ py: { xs: 2, md: 2 } }}>
      <Box
        sx={{
          mb: 3,
          py: { xs: 2, md: 2 },
          px: { xs: 2, md: 4 },
          borderRadius: '7px',
          width: '100%',
          height: { xs: '130px', md: '120px' },
          display: 'flex',
          flexDirection: 'column',
          backgroundImage: `url(${bannerBg})`,
          backgroundSize: 'cover',
          backgroundPosition: { xs: 'left', md: 'center' },
          backgroundRepeat: 'no-repeat',
        }}
      >
        <Typography
          variant="h4"
          sx={{
            mb: { xs: 0.2, md: 0.3 },
            fontWeight: 'bold',
            fontSize: { xs: '22px', md: '30px' },
            color: theme.palette.grey[900],
          }}
        >
          Contact Support
        </Typography>
        <Typography
          variant="body1"
          sx={{
            mb: { xs: 0.2, md: 0.3 },
            fontWeight: 700,
            fontSize: { xs: '15px', md: '16px' },
            color: theme.palette.grey[900],
          }}
        >
          Have a question or need assistance?
        </Typography>

        <Typography
          variant="body1"
          sx={{
            fontWeight: 400,
            fontSize: { xs: '15px', md: '16px' },
            color: theme.palette.grey[900],
          }}
        >
          Fill out the form below and we'll get back to you as soon as possible.
        </Typography>
      </Box>

      {formUrl ? (
        <Box
          sx={{
            width: '100%',
            borderRadius: 2,
            overflow: 'hidden',
          }}
        >
          <iframe
            title="Contact Form"
            className="clickup-embed clickup-dynamic-height"
            src={formUrl}
            width="100%"
            style={{
              marginTop: '-200px',
              height: 'calc(100dvh - 80px)',
              background: 'transparent',
              border: 'none',
              borderRadius: 8,
            }}
            sandbox="allow-scripts allow-forms allow-popups allow-same-origin"
          />
          <script async src="https://app-cdn.clickup.com/assets/js/forms-embed/v1.js" />
        </Box>
      ) : (
        <Typography
          variant="body1"
          sx={{
            textAlign: 'center',
            mt: 4,
          }}
        >
          {isLoading ? 'Loading...' : 'Contact form is disabled. Please contact your administrator.'}
        </Typography>
      )}
    </Container>
  );
};
